import React from "react";
import ReactDom from "react-dom";
import Carousel from 'react-bootstrap/Carousel';

function BaseballCarousel() {
return (
  <div className="baseball-slides">
  <div className="baseball-carousel">
  <Carousel fade>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/C27A1298.JPG`}
        alt="Baseball photo 1"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/C27A1319.JPG`}
        alt="Baseball photo 2"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/C27A1320.JPG`}
        alt="Baseball photo 3"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/IMG_6512.JPG`}
        alt="Baseball photo 4"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/IMG_6479.JPG`}
        alt="Baseball photo 5"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/Abbey Liao - PP BSB Grad-268.JPEG`}
        alt="Baseball photo 6"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/baseball1.jpeg`}
        alt="Baseball photo 7"
      />
    </Carousel.Item>
    <Carousel.Item>
      <img className="baseball-pictures"
        src={`${process.env.PUBLIC_URL}/images/0J9A5036.jpeg`}
        alt="Baseball photo 8"
      />
    </Carousel.Item>
    
  </Carousel>
  </div>
  </div>
);
}

export default BaseballCarousel;
